import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Amplify from 'aws-amplify';

const config = {
  Auth: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
    region: process.env.REACT_APP_COGNITO_REGION,
    mandatorySignIn: true,
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      redirectSignIn: `${window.location.protocol}//${window.location.host}/`,
      redirectSignOut: `${window.location.protocol}//${window.location.host}/`,
      responseType: 'code',
      scope: [
        'phone',
        'email',
        'profile',
        'openid',
        // 'aws.cognito.signin.user.admin',
        // readScope,
        // writeScope
      ],
      options: {
        AdvancedSecurityDataCollectionFlag: false
      }
    }
  }
};

Amplify.configure(config);

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
